//
export const CAPTION_BUTTON = "CAPTION_BUTTON";
export const CONTROLS = "CONTROLS";
export const GALLERY_BUTTON = "GALLERY_BUTTON";
export const INTERVIEW_SIDEBAR = "INTERVIEW_SIDEBAR";
export const LOOPING_VIDEOS = "LOOPING_VIDEOS";
export const SLIDESHOW_ARROWS = "SLIDESHOW_ARROWS";
export const COMPACT_CONTROLS = "COMPACT_CONTROLS";
